import { Type } from '@trustedshops/tswp-core-common';

export interface InjectableType<T> extends Type<T> {
  tswpDependencies: Array<{
    key: string | symbol;
    type: Type<T>;
    index: number;
  }>;
}
